import {ILanguageData} from '../../../textfield/manager/ILanguageData';
import {VersionInformation} from "../../VersionInformation";
import {BasicContextMenuController} from "../../controller/contextMenuController/BasicContextMenuController";
import {PathProvider} from "../../environment/providers/PathProvider";
import {LanguageDataEvent} from "../../event/LanguageDataEvent";
import {LanguageData, LocalizationModule, LanguageVO} from "@goodgamestudios/localization";
import {WorldAssignment} from "@goodgamestudios/world-assignment";
import {getLogger} from "@goodgamestudios/logger";

import {URLRequest, URLLoaderService} from "@goodgamestudios/createjs-utilities";
const logger = getLogger("BasicLanguageData");
import Event = createjs.Event;
import EventDispatcher = createjs.EventDispatcher;
import {IEnvironmentGlobals} from "../../IEnvironmentGlobals";
import {EnvGlobalsHandler} from "../../EnvGlobalsHandler";

export class BasicLanguageData extends EventDispatcher implements ILanguageData {
    public static GAME_LANGUAGE_DICTIONARY: string = "gameLanguageDict";

    // NO USAGE IN EMPIRE NOR BIGFARM
    // protected gameLanguageDict: Map<any, any>;

    private _worldAssignemnt: WorldAssignment;
    private _addPipeToEndOfString: boolean = true;
    private _languageDataLoaded: boolean;
    private _languageCode: string;

    constructor(private versionInformation: VersionInformation, private pathProvider: PathProvider, private locaModule: LocalizationModule) {
        super();

        this._worldAssignemnt = window.ggs.worldAssignment;
    }

    public checkSingleOrMultiText(value: number, textId: string, params: any[] = null): string {
        if (value === 1) {
            return this.getTextById(textId + "_single", params);
        } else {
            return this.getTextById(textId, params);
        }
    }

    /**
     * The method is a wrapper around Localize.text method, if there is no translation for an ID
     * an empty string will be returned
     *
     * @param id An ID to look translation for
     * @param params Replacements for placeholders if there are any
     * @return Returns a translation if it is found, an empty string otherwise
     */
    public getTextById(id: string, params: Object = null): string {
        return this.locaModule.localizeService.text(id, params);
    }

    // FIXME @HTML5 what's the use case of this?  changed from xml to json
    // protected insertXMLTextToDict(dict: Map<any, any>, text: XML): void {
    //     if (text.hasComplexContent()) {
    //         for (let subtext of text.children())
    //             this.insertXMLTextToDict(dict, subtext);
    //     }
    //     else if (text.attribute('id') != "") {
    //         dict.set(String(text.attribute('id')).toLocaleLowerCase(), StringConverter.unescapeString(text.attribute('name')));
    //     }
    // }

    /**
     * return an Dictionary includes all text where category is in structArray-param
     */

    private onLanguageDataLoaded(translations: LanguageData): void {
        logger.debug(`onLanguageDataLoaded ${this._languageCode} version: ${translations["@metadata"].versionNo}`);
        this.versionInformation.parseLanguageXml(translations);
        //this.locaModule.setTexts(translations);  //Call the loadAsync().then(....dispatch....)
        const languageVO = new LanguageVO(
            this._worldAssignemnt.facade.currentCountry.ggsCountryCode,
            this._languageCode,
            this.env.neverUseAbbreviations,
            this.env.abbreviationThreshold,
            this.env.fractionalDigits,
            this.env.leadingZero,
            this.env.trailingZeros);
        this.locaModule.setLanguageAsync(languageVO, translations).then(() => {

            BasicContextMenuController.instance.refreshVersionInfo();
            this._languageDataLoaded = true;
            this.dispatchEvent(new LanguageDataEvent(LanguageDataEvent.XML_LOAD_COMPLETE));
        }).catch(error => {
            logger.error(`Error in Globalize loader: ${error}`)
        });
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    /**
     * Use regex to read the language code from the URL filename  (it could contain locale variations  ie  de  or zh_TW)
     * @param url {string} the URL for the translations JSON
     */
    private getLanguageFromUrl(url: string): string {
        return url.match(/([^\/]+)(?=\.\w+$)/)[0];
    }

    public loadLanguage(url: string = this.pathProvider.languageConfigURL): void {
        logger.debug(`will load language from ${url}`);
        if (!this._languageDataLoaded) {
            this._languageCode = this.getLanguageFromUrl(url); //save the language code from the translation URL, needed by Globalization in setLanguageAsync
            let loader = new URLLoaderService(new URLRequest(url));
            loader.load().then(response => {
                logger.debug("language loaded successfully");
                this.onLanguageDataLoaded(JSON.parse(response))
                loader.dispose();
            }).catch(error => {
                    logger.error("Error while loading/parsing json", error);
                    loader.dispose();
                    this.dispatchEvent(new LanguageDataEvent(LanguageDataEvent.LANGUAGE_GENERIC_ERROR));
                }
            )
        }
        else {
            // languageXMLLoaded is used inside GoodgameTextFieldManager.updateText  and set to false by BasicChangeLanguageCommand.
            logger.warn("load language not executed because it was already loaded.  if you want to change the language use BasicChangeLanguageCommand");
        }
    }


    // no usages in BF / Empire--> only in toolbox
    public get languageXMLLoaded(): boolean {
        return this._languageDataLoaded;
    }

    // no usages in BF / Empire--> only in toolbox
    public set languageXMLLoaded(value: boolean) {
        this._languageDataLoaded = value;
    }

    public get addPipeToEndOfString(): boolean {
        return this._addPipeToEndOfString;
    }

    public set addPipeToEndOfString(value: boolean) {
        this._addPipeToEndOfString = value;
    }
}


